var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "mxa2unywba",
    d: "M0.922 0.511L22.229 0.511 22.229 21.817 0.922 21.817z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ynawxwyybc",
    d: "M0 0.153L11.568 0.153 11.568 12 0 12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 .49)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "slbs5s5zrb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#mxa2unywba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#B8A16B",
    d: "M11.576.51C5.692.51.922 5.28.922 11.165c0 1.822.459 3.536 1.265 5.035.118.06.232.13.334.218.166-.43.509-.768.976-.923.172-.058.354-.088.537-.088.716 0 1.347.453 1.57 1.127.238.718.39 1.213.52 1.639.109.355.203.66.32 1.01l.02.058c.092.267.183.53.273.784.283-.428.573-.716.672-.793.229-.17.674-.44 1.23-.44.22 0 .43.043.626.128.484.23.82.584.966 1.01.102.294.162.77-.13 1.352-.047.087-.112.23-.182.407.54.084 1.093.128 1.657.128 5.884 0 10.654-4.768 10.654-10.652C22.23 5.28 17.46.51 11.576.51",
    mask: "url(#slbs5s5zrb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M11.054 8.932c0 .982-.796 1.78-1.779 1.78-.982 0-1.778-.798-1.778-1.78s.796-1.779 1.778-1.779c.983 0 1.779.797 1.779 1.78M19.655 8.932c0 .982-.796 1.78-1.78 1.78-.981 0-1.777-.798-1.777-1.78s.796-1.779 1.778-1.779c.983 0 1.779.797 1.779 1.78M13.576 18.293c-2.821 0-5.341-1.789-6.27-4.451-.102-.292.052-.611.344-.713.293-.103.612.051.714.344.772 2.213 2.867 3.7 5.212 3.7 2.345 0 4.44-1.487 5.212-3.7.102-.292.422-.447.714-.344.292.102.446.421.344.713-.93 2.662-3.45 4.451-6.27 4.451"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 16.49)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hz47rf598d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ynawxwyybc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7A6130",
    d: "M10.965 3.605c-.366-.16-.8-.005-1.098.217-.084.065-.994.991-1.028 2.067-.002.079-.104.109-.139.038-.34-.689-.636-1.554-.964-2.505-.261-.775-.405-1.335-.84-2.654-.157-.473-.675-.73-1.164-.565-.473.157-.684.65-.534 1.147.069.202.488 1.489.867 2.739.035.101-.111.2-.195.046-1.016-1.801-1.333-2.387-1.641-2.917C3.971.779 3.41.625 2.971.883c-.438.257-.577.811-.334 1.258.083.154.861 1.626 1.579 2.95.092.17-.046.245-.152.123-.403-.559-1.521-2.106-1.719-2.397-.303-.413-.871-.504-1.269-.209-.413.304-.489.863-.209 1.269.141.223.982 1.481 1.848 2.746.008.015-.006.063-.028.095-.031.017-.077.042-.094.011-.473-.541-1.11-1.312-1.388-1.64-.252-.281-.684-.306-.974-.069-.282.252-.307.684-.07.974.172.206 1.607 1.86 2.488 2.897.678.809 1.319 1.697 1.705 2.225.427.605 1.777 1.448 3.798.353.817-.443 1.89-1.023 2.176-2.237 0 0 .12-.662.359-1.948.179-.994.546-1.971.746-2.338.316-.63.042-1.099-.468-1.341",
    mask: "url(#hz47rf598d)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.9bc7601d0f0fcfeaf6e5a739a501195d.svg";
export { ForwardRef as ReactComponent };